module.exports = __webpack_public_path__ + "media/step3_animation.f128b16d.webm";